"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CoachUser {
    constructor(userRepository) {
        this.getPersonalInformation = (token) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const user = await this.userRepository.getUserByToken(token);
                    resolve({
                        id: user.id,
                        name: "Johhny B. Goode",
                        email: user.email,
                        birthDate: "1917-05-29",
                        telephoneNumber: "+00 123 456 789",
                        roles: [],
                    });
                }
                catch (e) {
                    reject(e);
                }
            });
        };
        this.userRepository = userRepository;
    }
}
exports.default = CoachUser;
//# sourceMappingURL=CoachUser.js.map